export default __webpack_public_path__ + "static/ADOT-performance-f1c00f7e529dc23751e816e5824e8289.png";